import request from './request.config'
import * as apiConfig from './api.config'

export default {
  request,
  apiConfig
}
